import { searchUsersGroups } from '../../../Infrastructure/Store/groups/groups.action';
import { searchUser } from '../../../Infrastructure/Store/users/users.actions';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import { DataTranslatePages } from 'projects/access-control/src/app/Domain/Entities/data-translate-pages';
import FilterList, {
	FilterValues,
	OptionsFilter,
} from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';
import { Groups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { OptionsTable } from 'projects/access-control/src/app/Domain/Entities/options-table.interface';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { UsersGroups } from 'projects/access-control/src/app/Domain/Entities/userGroups.interface';
import { FilterTablePipe } from 'projects/access-control/src/app/Infrastructure/pipes/filter-table.pipe';
import {
	deleteBulkUsersGroups,
	getUsersGroups,
} from 'projects/access-control/src/app/Infrastructure/Store/groups/groups.action';
import { deleteUser, getUser } from 'projects/access-control/src/app/Infrastructure/Store/users/users.actions';
import {
	IPermissions,
	IRole,
	IRosources,
	RolesUserService,
	TranslateService,
} from '@mangosoft/mango-layout';
import { Store } from '@ngrx/store';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ModalUsersComponent } from '../modal-users/modal-users.component';
import filtersUserTable from './dataSearchUsers';
import { FiltersService } from 'projects/access-control/src/app/Infrastructure/Services/filters/filters.service';
import { InfoPermissions } from 'projects/access-control/src/app/Domain/Entities/roles.interface';

interface TranslateUsers extends DataTranslatePages {
	delete: string;
	bulkDeletes: string;
	table: {
		columns: { label: string; name: string }[];
		status: string;
		username: string;
		phone: string;
		actions: string;
		searchGroups: FilterList[];
		search: FilterList[];
	};
}
@Component({
	selector: 'app-table-users',
	templateUrl: './table-users.component.html',
	styleUrls: ['./table-users.component.scss'],
})
export class TableUsersComponent implements OnInit, OnChanges, OnDestroy {
	@Input() group: Groups = {} as Groups;
	@Input() userTable: UsersGroups[] = [];
	@Input() pagination: DataPagination = {} as DataPagination;
	@Input() loading: boolean = false;
	@Input() heigthTable = 347;
	@Input() columnsFilter: OptionsFilter[] = [];

	elementsDelete: string = '';
	isLoading = false;
	destroy$ = new Subject<void>();

	userTableRow: UsersGroups[] = [];
	translateUsers: TranslateUsers = {} as TranslateUsers;
	subscriptionTranslate!: Subscription;
	selectionType = SelectionType;
	disabledRefresh = true;
	userSelectedDelete: UsersGroups = {} as UsersGroups;
	columns = [
		{ name: 'fullName', label: 'FullName' },
		{ name: 'Email', label: 'Email' },
	];
	modeColum!: any;
	nameModal = 'modalAlertDeleteElement';
	openAlert = false;
	valueModalDelete = '';
	selected: UsersGroups[] = [];
	filterResults: FilterValues[] = [] as FilterValues[];
	filterList: FilterList[] = filtersUserTable;
	url = '';
	activateFilter = false;
	viewDelete: boolean = false;
	optionsTable: OptionsTable[] = [
		{
			value: 'edit',
			icon: 'edit',
		},
		{
			value: 'delete',
			icon: 'delete',
		},
	] as OptionsTable[];
	optionsTableUser: OptionsTable[] = [
		{
			value: 'edit',
			icon: 'edit',
		},
	] as OptionsTable[];

	constructor(
		public dialog: MatDialog,
		private store: Store,
		private filter: FilterTablePipe,
		private translateService: TranslateService,
		private filterService: FiltersService,
		private roleUserService: RolesUserService
	) {}

	ngOnInit(): void {
		this.userTableRow = [...this.userTable];
		this.modeColum = ColumnMode.force;
		this.getTranslate();
		this.validateRoles();
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.userTableRow = [...this.userTable];
		this.isLoading = this.loading;
	}

	filterSelected(options: OptionsFilter[]) {
		this.url = this.filterService.createUrl(options);
		if (this.group.sk) {
			if (this.url.length > 0) {
				this.activateFilter = true;
				this.store.dispatch(
					searchUsersGroups({
						group: { pk: this.group.pk, sk: this.group.sk },
						url: this.url,
					})
				);
			} else {
				this.activateFilter = false;
				this.store.dispatch(
					getUsersGroups({
						group: { pk: this.group.pk, sk: this.group.sk },
						paginationTo: 1,
					})
				);
			}
		} else {
			if (this.url.length > 0) {
				this.activateFilter = true;
				this.store.dispatch(searchUser({ url: this.url }));
			} else {
				this.activateFilter = false;
				this.store.dispatch(getUser({ paginationTo: 1 }));
			}
		}
	}
	buttonAction(option: string) {
		if (option === 'refresh') {
			this.disabledRefresh = true;
		} else {
			this.elementsDelete = '';
			if (this.selected.length > 0) {
				this.nameModal = 'modalAlertDeleteElement';
				this.elementsDelete =
					this.selected.length > 1
						? `${this.selected.length} ${this.translateUsers.bulkDeletes}`
						: `${this.translateUsers.delete} '${this.selected[0]?.fullName}'`;
			} else {
				this.nameModal = 'modalAlertDeleteNoSelected';
			}
			this.valueModalDelete = 'bulkDelete';
			this.openAlert = true;
		}
	}

	getFilterValues(filter: FilterValues[]) {
		this.filterResults = filter;
		this.userTableRow = this.filter.transform(this.userTable, filter) as UsersGroups[];
	}
	refreshData(event: any) {
		if (this.group.sk) {
			this.store.dispatch(
				getUsersGroups({
					group: { pk: this.group.pk, sk: this.group.sk },
					paginationTo: 1,
				})
			);
		} else {
			this.store.dispatch(
				getUser({
					paginationTo: 1,
				})
			);
		}
	}
	onSelect({ selected }: any) {
		this.selected.splice(0, this.selected.length);
		selected.forEach((element: any) => {
			this.selected.push(element);
		});
	}
	emitNavigation(numberPage: number) {
		if (this.group.sk) {
			if (this.activateFilter) {
				this.store.dispatch(
					searchUsersGroups({
						group: { pk: this.group.pk, sk: this.group.sk },
						url: `${this.url}&_size=10&_page=${numberPage}`,
					})
				);
			} else {
				this.store.dispatch(
					getUsersGroups({
						group: { pk: this.group.pk, sk: this.group.sk },
						paginationTo: numberPage,
					})
				);
			}
		} else {
			if (this.activateFilter) {
				this.store.dispatch(searchUser({ url: `${this.url}&_size=10&_page=${numberPage}` }));
			} else {
				this.store.dispatch(
					getUser({
						paginationTo: numberPage,
					})
				);
			}
		}
	}
	actions(event: any) {
		if (event.action === 'edit') {
			const dialogRef = this.dialog.open(ModalUsersComponent, {
				height: '750px',
				width: '600px',
				data: {
					type: this.group.sk ? 'updateUser' : 'updateGlobalUser',
					group: this.group,
					user: event.value,
				},
			});
		} else {
			this.userSelectedDelete = event.value;
			this.elementsDelete = `${this.translateUsers.delete} '${event.value.fullName}'`;
			this.valueModalDelete = 'delete';
			this.openAlert = true;
		}
	}

	closeModalAlert(valueModal: any) {
		if (valueModal.resp && valueModal.value === 'delete') {
			this.group.sk
				? this.store.dispatch(
						deleteBulkUsersGroups({
							user: [this.userSelectedDelete.username],
							ids: { pk: this.group.pk, sk: this.group.sk },
						})
				  )
				: this.store.dispatch(deleteUser({ user: [this.userSelectedDelete.username] }));
		} else if (valueModal.resp && valueModal.value === 'bulkDelete') {
			const user: string[] = this.selected.map((user) => {
				return user.username;
			});
			this.group.sk
				? this.store.dispatch(
						deleteBulkUsersGroups({ user, ids: { pk: this.group.pk, sk: this.group.sk } })
				  )
				: this.store.dispatch(deleteUser({ user }));
		}
		this.openAlert = false;
		this.selected = [];
		this.elementsDelete = '';
		this.userSelectedDelete = {} as UsersGroups;
	}

	getTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.translateUsers = data.pages.users;
			this.filterList = this.group.sk
				? this.translateUsers.table.searchGroups
				: this.translateUsers.table.search;
			this.columns = this.translateUsers.table.columns;
		});
	}
	validateRoles() {
		const permissionData = this.roleUserService.getPermissionsObject();
		this.validDelete(permissionData.permissions);
		this.roleUserService.getPermissions
			.pipe(takeUntil(this.destroy$))
			.subscribe((resp: IPermissions) => {
				this.validDelete(resp.permissions);
			});
	}

	validDelete(permissions: InfoPermissions[]) {
		let roles: IRole[] = [];
		if (permissions) {
			permissions.forEach((permissions) => {
				if (permissions.host === location.hostname) {
					roles = permissions.roles;
				}
			});
			let allResources: IRosources[] = [];
			roles.forEach((role) => {
				allResources.push(...role.resources);
			});
			this.viewDelete = allResources.some(
				(resource) =>
					resource.path.toLowerCase().includes('users') &&
					resource.action.toLowerCase().includes('delete')
			);
		}
	}
	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();

		this.subscriptionTranslate?.unsubscribe();
	}
}
